<template lang="pug">
div.Welcome
    div.main-Welcome.Absolutely-Centralization
        //- img.y(src='../../assets/doCase/y.png')
        img(src="../../assets/doCase/jd.png")
        //- h1.title  欢迎进入本案例实训
        //- p.content   欢迎进入本案例实训，在政策制定阶段你将扮演的是卫计委（计生委）部门的政策分析师，协助领导进行政策的问题认定、评估备选方案等任务。
        button.start(@click="start").y 进入政策制定
          <Icon type="md-arrow-round-forward" />
        div
          img(src="../../assets/Noviceguide/小手.png", alt="提示").finger
          p.text-Explain  点击进入实训
</template>
<script>
export default {
  methods: {
    start() {
      this.$emit("start");
    }
  }
};
</script>
<style lang="stylus" scoped>
.Welcome
  height 100vh
  width 100vw
  position fixed
  background rgba(42, 46, 54, 0.7)
  z-index 10
.text-Explain
  font-size 20px
  font-family STYuanti-SC-Bold, STYuanti-SC
  font-weight bold
  color rgba(255, 255, 255, 1)
  white-space nowrap
  position absolute
  // right: -30%;
  left 100%
  bottom: -10%;
@keyframes myfirst
  from
    left 50%
    top -55px
  to
    left 51%
    top -70px
.finger
  z-index 99999
  position relative
  left 65%
  top -55px
  // transition 1s
  animation myfirst .5s infinite
  animation-direction:alternate;
.main-Welcome
  // width 800px
  width 997px
  height 376px
  position relative
  top: 30%;
  .y
    position absolute
    left: 90%;
  .title
    font-size 20px
    font-family MicrosoftYaHeiUI
    color rgba(255, 255, 255, 1)
    line-height 25px
    margin-top 16px
  .content
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(255, 255, 255, 1)
    line-height 28px
    text-align left
    margin-top 24px
  button
    border-radius 4px
    border none
    outline none
    cursor pointer
    font-size 20px
    font-family MicrosoftYaHeiUI
    color #fff
    line-height 18px
    display block
    text-align center
    transition all 0.3s
    &:hover
      opacity 0.9
    &:active
      opacity 0.8
  .Buttons
    display flex
    flex-direction column
    justify-content center
    align-items center
  .Cancel
    width 60px
    height 40px
    color #fff
    background rgba(0, 0, 0, 0)
    display block
    margin-top 8px
  .Submission
    width 140px
    height 40px
    background #3a76d2
    margin 24px auto
  [custom]
    margin 0
    width 140px
  .download
    font-size 14px
    font-family MicrosoftYaHeiUI
    color #fff
    line-height 18px
    margin-top 24px
    display inline-block
    cursor pointer
    border-bottom 1px solid #ffffff
.start
  width 208px
  height 56px
  background rgba(68, 133, 240, 1)
  box-shadow 0px 0px 4px 2px rgba(255, 255, 255, 0.8)
  border-radius 4px
  position absolute
  left 50%
  top 80%
  outline none
  border none
  font-size 20px
  font-family MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI
  font-weight bold
  position absolute
  color rgba(255, 255, 255, 1)
  transform translate(-50%, -50%)
</style>
